<template>
  <div class="button-dropdown d-flex w-100">
    <div
      class="dropdown position-relative d-flex justify-content-between align-items-center"
      @click="toggleDropdown"
    >
      <p
        :class="{ 'f-c-white': true, 'f-Overpass': true }"
        class="m-0 f-12 f-w-600"
      >
        {{ selectedOption }}
      </p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z"
          fill="white"
        />
      </svg>
      <div class="drop-list position-absolute mt-2" v-show="isDropdownOpen">
        <div
          v-for="(option, index) in dropdownOptions"
          :key="index"
          class="drop-list_item px-3 py-2 d-flex"
          :class="{
            'selected-item': isDropdownOpen && selectedIndex === index,
          }"
          @click="selectOption(option, index)"
        >
          <p
            :class="{ 'f-c-blue': selectedIndex === index, 'f-Overpass': true }"
            class="m-0 f-12 f-w-600"
          >
            {{ option }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "dropTrans",
  data() {
    return {
      selectedOption: "Semua transaksi",
      isDropdownOpen: false,
      selectedIndex: 0,
      dropdownOptions: ["Semua transaksi", "Penggunaan Mesin", "Top-Up"],
    };
  },
  computed: {
    ...mapState("riwayat", {
      pagination: "pagination",
      jenis: "jenis",
      outlet: "outlet",
    }),
  },
  methods: {
    ...mapActions({
      resetPagination: "riwayat/resetPagination",
      resetDataRiwayat: "riwayat/resetDataRiwayat",
      postHistory: "riwayat/postHistory",
      resetlengthRiwayat: "riwayat/resetlengthRiwayat",
    }),
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    async selectOption(option, index) {
      await this.resetDataRiwayat();
      await this.resetPagination();
      await this.resetlengthRiwayat();
      this.selectedOption = option;
      this.selectedIndex = index;
      this.isDropdownOpen = true;

      if (this.selectedOption == "Semua transaksi") {
        this.$store.commit("riwayat/setJenisRiwayat", "");
      }
      if (option == "Penggunaan Mesin") {
        this.$store.commit("riwayat/setJenisRiwayat", "snap_transaksi");
      }
      if (this.selectedOption == "Top-Up") {
        this.$store.commit("riwayat/setJenisRiwayat", "pembelian_emoney");
      }

      let data = {
        skip: this.pagination.skip,
        limit: this.pagination.limit,
        jenis: this.jenis,
        outlet: this.outlet,
      };
      await this.postHistory(data);
    },
  },
};
</script>

<style scoped>
.dropdown {
  padding: 8px 16px;
  gap: 8px;
  width: 100%;
  border-radius: 44px;
  background: var(--information-blue-normal, #206cfe);
  cursor: pointer;
  z-index: 2;
}

.drop-list {
  background-color: white;
  border-radius: 5px;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 2;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
}

.drop-list_item {
  transition: background-color 0.3s;
}

.drop-list_item:hover {
  background-color: #f5f5f5;
}

.dropdown:hover .drop-list {
  display: block;
}

.selected-item {
  background-color: #edf5ff;
}
</style>
